export enum PapelServicoEnum {

  prestador = "Prestador",
  tomador = "Tomador"
}
